<div class="pos-r padding-24" *ngIf="loading">
  <app-loader></app-loader>
</div>
<div *ngIf="!loading">
  <app-tickets-period-filter-new [ticketsPeriodFilter]="ticketsPeriodFilter"> </app-tickets-period-filter-new>

  <div class="filter-assign__wrapper" #filterAssignWrapper>
    <div class="filter-assign__container" #filterAssignContainer>
      <ng-container *ngIf="ticketsPage; else mapFilters">
        <ng-container *ngIf="isGRSUser(); else ticketsFilter">
          <app-tickets-grs-filter-new
            [ticketsPeriodFilter]="ticketsPeriodFilter"
            [ticketsMultipleAssign]="ticketsMultipleAssign"
            [ticketsCurrentFilter]="ticketsCurrentFilter"
            [tickets]="tickets"
            [brigadeAssign]="brigadeAssignData"
          ></app-tickets-grs-filter-new>
        </ng-container>
      </ng-container>

      <ng-template #ticketsFilter>
        <app-tickets-current-filter-new
          [ticketsCurrentFilter]="ticketsCurrentFilter"
          [brigadeAssign]="brigadeAssignData"
          [automaticDistribution]="automaticDistribution"
        >
        </app-tickets-current-filter-new>
        <app-tickets-multiple-assign-new [ticketsMultipleAssign]="ticketsMultipleAssign"> </app-tickets-multiple-assign-new>
      </ng-template>
      <ng-template #mapFilters>
        <app-tickets-map-filter-new [ticketsCurrentFilter]="ticketsCurrentFilter" [brigadeAssign]="brigadeAssignData"> </app-tickets-map-filter-new>
      </ng-template>
    </div>
  </div>

  <ng-container *ngIf="!(automaticDistribution && (automaticDistribution.showMap || automaticDistribution.showSchedule)); else automaticDistributionScreen">
    <ng-container *ngIf="ticketsCurrentFilter.mode === 'table'">
      <ng-container *ngIf="!isGRSUser(); else grsList">
        <app-tickets-list-new
          [brigadeAssign]="brigadeAssignData"
          [filter]="parentParams"
          [ticketsCurrentFilter]="ticketsCurrentFilter"
          [ticketsPeriodFilter]="ticketsPeriodFilter"
          [ticketsMultipleAssign]="ticketsMultipleAssign"
          [tickets]="tickets"
        ></app-tickets-list-new>
      </ng-container>
      <ng-template #grsList>
        <app-tickets-grs-list-new
          [brigadeAssign]="brigadeAssignData"
          [filter]="parentParams"
          [ticketsCurrentFilter]="ticketsCurrentFilter"
          [ticketsPeriodFilter]="ticketsPeriodFilter"
          [ticketsMultipleAssign]="ticketsMultipleAssign"
          [tickets]="tickets"
        ></app-tickets-grs-list-new>
      </ng-template>
    </ng-container>

    <ng-container *ngIf="ticketsCurrentFilter.mode === 'matrix'">
      <app-tickets-matrix-new
        [brigadeAssign]="brigadeAssignData"
        [filter]="parentParams"
        [ticketsCurrentFilter]="ticketsCurrentFilter"
        [ticketsPeriodFilter]="ticketsPeriodFilter"
        [ticketsMultipleAssign]="ticketsMultipleAssign"
        [tickets]="tickets"
      ></app-tickets-matrix-new>
    </ng-container>

    <ng-container *ngIf="ticketsCurrentFilter.mode === 'map'">
      <app-tickets-map-new
        class="filter-assign__map"
        [brigadeAssign]="brigadeAssignData"
        [filter]="parentParams"
        [ticketsCurrentFilter]="ticketsCurrentFilter"
        [ticketsPeriodFilter]="ticketsPeriodFilter"
        [ticketsMultipleAssign]="ticketsMultipleAssign"
        [tickets]="tickets"
      ></app-tickets-map-new>
    </ng-container>
  </ng-container>

  <ng-template #automaticDistributionScreen>
    <app-automatic-distribution-result-new
      [automaticDistribution]="automaticDistribution"
      [tickets]="tickets"
      [brigades]="ticketsMultipleAssign.brigades"
    ></app-automatic-distribution-result-new>
  </ng-template>
</div>
